import { Button } from "@rneui/themed";
import React, { useContext } from "react";
import { View } from "react-native";
import { NavigationContext } from "../../../providers";
import { Description, Image } from "../../shared";
import { getBreakpoint } from "../utils";
const PADDING_BOTTOM = 52;
export const CarouselOverlay = ({ slide, screenWidth, slideHeight, }) => {
    const breakpoint = getBreakpoint(screenWidth);
    const isMobile = breakpoint === "mobile";
    const isDesktop = breakpoint === "desktop";
    const { onNavigate } = useContext(NavigationContext);
    const maxDescriptionHeight = ((slideHeight - PADDING_BOTTOM) / 4) *
        (1 + (slide?.overlayImage?.src ? 0 : 1) + (slide?.ctaText ? 0 : 1));
    return (React.createElement(View, { style: [
            {
                justifyContent: "flex-end",
                paddingHorizontal: isDesktop ? 72 : 52,
                width: isMobile ? screenWidth : screenWidth * 0.6,
                maxWidth: "100%",
                height: slideHeight,
            },
        ] },
        React.createElement(View, { style: [
                {
                    width: "100%",
                    height: "100%",
                    justifyContent: isMobile ? "flex-end" : "flex-start",
                    alignItems: "center",
                    flexDirection: isMobile ? "column" : "row",
                    paddingBottom: PADDING_BOTTOM,
                },
            ] },
            React.createElement(View, { style: {
                    alignItems: isMobile ? "center" : "flex-start",
                    justifyContent: isMobile ? "flex-end" : "center",
                    width: "100%",
                    height: "100%",
                    gap: 12,
                } },
                slide?.overlayImage?.src && (React.createElement(Image, { resizeMode: "contain", heightConstraint: breakpoint === "mobile"
                        ? 80
                        : breakpoint === "tablet"
                            ? 120
                            : 150, uri: slide.overlayImage.src })),
                slide?.description && (React.createElement(Description, { text: slide.description, color: "white", maxHeight: (slideHeight - PADDING_BOTTOM) / 4, containerStyle: {
                        alignItems: isMobile ? "center" : "flex-start",
                        margin: 0,
                    }, showExpandButton: false })),
                slide?.ctaText && (React.createElement(Button, { title: slide.ctaText, size: "lg", titleStyle: { fontSize: 18 }, onPress: () => slide?.ctaLink && onNavigate(slide.ctaLink) }))))));
};
//# sourceMappingURL=CarouselOverlay.js.map